module.exports = __webpack_public_path__ + "static/media/stoplight-loosejaw.e4ce4803.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/stoplight-loosejaw.png
// module id = 337
// module chunks = 0